import moment from 'moment';

import {
  getFormValue,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum, MessagesEnum } from 'app/shared/enums';

const formName = FormsEnum.TravelForm;

export const setGracePeriodInfoMessagesVisibility = (
  startDate: string,
  currentlyInPoland: boolean
) => {
  const startsToday = moment().isSame(moment(startDate), 'day');

  setMessageVisibility({
    key: MessagesEnum.TravelTodayStartDateGracePeriodInfoOther,
    visible: startsToday && currentlyInPoland,
    formName,
  });

  setMessageVisibility({
    key: MessagesEnum.TravelTodayStartDateGracePeriodInfoAxa,
    visible: startsToday && !currentlyInPoland,
    formName,
  });
};

export const currentlyInPoland = {
  changeCurrentlyInPoland() {
    const currentlyInPoland = getFormValue(
      FieldsEnum.TravelAllTravelersCurrentlyInPoland,
      formName
    );
    const startDate = getFormValue(FieldsEnum.TravelStartDate, formName);

    setGracePeriodInfoMessagesVisibility(startDate, currentlyInPoland);
  },
};
